export const heroData = {
  tag: "全网最全 · 极速播放 · 蓝光画质",
  h1: "91电影视频 — 超清4K影视，免费流畅在线看",
  slogan: "每日更新 · 海量片库 · 纯净无广告观影体验",
  intro: "91电影视频是国内领先的高清影视在线平台，聚合全网最新最全的电影、电视剧、综艺、动漫资源。我们采用先进的视频压缩与CDN加速技术，确保4K超清画质下依然流畅不缓冲，让每一位影迷都能享受极致的视听盛宴。平台每日同步更新院线新片、热播剧集，片库涵盖动作、喜剧、科幻、悬疑、爱情等全品类内容，无论你是追剧党还是电影发烧友，这里都是你的最佳观影选择。",
  stats: [
    { value: "20,000+", label: "高清片库" },
    { value: "100+", label: "每日更新" },
    { value: "80%", label: "4K超清占比" },
  ],
  ctaPrimary: { text: "开始观影", href: "#media" },
  ctaSecondary: { text: "浏览片库", href: "#index" },
};

export const mediaData = [
  {
    id: 1,
    title: "《星际迷航：新纪元》",
    tag: "4K 科幻巨制",
    quality: "4K HDR",
    duration: "148分钟",
    year: "2026",
    rating: "9.2",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20style%2C%20futuristic%20spaceship%20in%20deep%20space%20with%20nebulae%2C%20dramatic%20lighting%2C%20dark%20blue%20and%20gold%20color%20palette%2C%20epic%20cinematic%20composition%2C%20film%20grain%20texture%2C%20professional%20movie%20poster%20design%2C%20clean%20background&width=640&height=900&seq=media-01&orientation=portrait",
    views: "328万",
  },
  {
    id: 2,
    title: "《暗夜追踪》",
    tag: "悬疑犯罪大片",
    quality: "4K",
    duration: "126分钟",
    year: "2026",
    rating: "8.8",
    image: "https://readdy.ai/api/search-image?query=Noir%20crime%20thriller%20movie%20poster%20style%2C%20detective%20in%20rainy%20city%20street%20at%20night%2C%20neon%20reflections%20on%20wet%20pavement%2C%20mysterious%20atmosphere%2C%20dark%20and%20moody%20lighting%2C%20professional%20film%20poster%20design%2C%20clean%20cinematic%20background&width=640&height=900&seq=media-02&orientation=portrait",
    views: "256万",
  },
  {
    id: 3,
    title: "《山河令：续》",
    tag: "古装武侠巨献",
    quality: "4K 杜比",
    duration: "52集全",
    year: "2026",
    rating: "9.5",
    image: "https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20drama%20poster%20style%2C%20warrior%20in%20flowing%20white%20robes%20standing%20on%20misty%20mountain%20peak%2C%20traditional%20Chinese%20ink%20painting%20aesthetic%2C%20soft%20golden%20light%2C%20elegant%20composition%2C%20clean%20artistic%20background&width=640&height=900&seq=media-03&orientation=portrait",
    views: "512万",
  },
  {
    id: 4,
    title: "《极寒之战》",
    tag: "动作冒险巨作",
    quality: "4K IMAX",
    duration: "135分钟",
    year: "2025",
    rating: "8.6",
    image: "https://readdy.ai/api/search-image?query=Action%20adventure%20movie%20poster%20style%2C%20soldier%20in%20snowy%20arctic%20landscape%20with%20explosions%20in%20background%2C%20ice%20and%20fire%20contrast%2C%20intense%20dramatic%20lighting%2C%20cinematic%20film%20poster%20design%2C%20clean%20epic%20background&width=640&height=900&seq=media-04&orientation=portrait",
    views: "198万",
  },
  {
    id: 5,
    title: "《花月往事》",
    tag: "年代情感剧集",
    quality: "4K 臻彩",
    duration: "48集全",
    year: "2026",
    rating: "9.1",
    image: "https://readdy.ai/api/search-image?query=Romantic%20period%20drama%20poster%20style%2C%20couple%20in%20traditional%201930s%20Shanghai%20attire%20under%20cherry%20blossoms%2C%20warm%20vintage%20tones%2C%20soft%20romantic%20lighting%2C%20elegant%20film%20poster%20design%2C%20clean%20nostalgic%20background&width=640&height=900&seq=media-05&orientation=portrait",
    views: "445万",
  },
];

export const appData = {
  title: "91电影视频 APP",
  subtitle: "随时随地，高清观影",
  description: "下载91电影视频手机客户端，支持离线缓存、投屏播放、画中画等强大功能。无论在地铁、咖啡厅还是家中，都能畅享4K超清影视体验。iOS与Android双平台全覆盖，扫码即可下载。",
  features: ["离线缓存", "4K投屏", "画中画播放", "倍速播放", "夜间模式"],
  image: "https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20showing%20movie%20streaming%20app%20interface%20with%20film%20posters%20grid%2C%20dark%20theme%20UI%20design%2C%20minimalist%20phone%20on%20clean%20desk%20surface%2C%20soft%20natural%20lighting%2C%20professional%20product%20photography%2C%20clean%20white%20background&width=600&height=900&seq=app-01&orientation=portrait",
};

export const rankingData = [
  { rank: 1, title: "山河令：续", type: "古装剧", score: "9.5", trend: "↑2", hot: "512万" },
  { rank: 2, title: "花月往事", type: "年代剧", score: "9.1", trend: "↑5", hot: "445万" },
  { rank: 3, title: "星际迷航：新纪元", type: "科幻片", score: "9.2", trend: "new", hot: "328万" },
  { rank: 4, title: "暗夜追踪", type: "悬疑片", score: "8.8", trend: "↑1", hot: "256万" },
  { rank: 5, title: "极寒之战", type: "动作片", score: "8.6", trend: "↓3", hot: "198万" },
  { rank: 6, title: "城市之光", type: "都市剧", score: "8.9", trend: "new", hot: "187万" },
];

export const indexData = [
  {
    id: 1,
    title: "科幻巨制专区",
    count: "386部",
    description: "星际、AI、未来世界，探索无限可能",
    image: "https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20cityscape%20with%20flying%20vehicles%20and%20neon%20lights%2C%20cinematic%20wide%20angle%2C%20deep%20space%20background%20with%20stars%2C%20epic%20atmosphere%2C%20professional%20film%20genre%20visual%2C%20clean%20composition&width=600&height=400&seq=index-01&orientation=landscape",
  },
  {
    id: 2,
    title: "悬疑烧脑剧场",
    count: "274部",
    description: "反转不断，挑战你的推理极限",
    image: "https://readdy.ai/api/search-image?query=Mysterious%20detective%20office%20with%20cork%20board%20and%20red%20strings%20connecting%20clues%2C%20dim%20warm%20lighting%2C%20noir%20atmosphere%2C%20cinematic%20composition%2C%20film%20genre%20visual%2C%20clean%20background&width=600&height=400&seq=index-02&orientation=landscape",
  },
  {
    id: 3,
    title: "动作冒险殿堂",
    count: "512部",
    description: "肾上腺素飙升的极致体验",
    image: "https://readdy.ai/api/search-image?query=Epic%20mountain%20climbing%20adventure%20scene%20with%20dramatic%20sunset%20sky%2C%20silhouette%20of%20climber%20on%20peak%2C%20golden%20hour%20lighting%2C%20cinematic%20wide%20angle%2C%20adventure%20film%20genre%20visual%2C%20clean%20background&width=600&height=400&seq=index-03&orientation=landscape",
  },
  {
    id: 4,
    title: "浪漫爱情合集",
    count: "358部",
    description: "从青涩到永恒，每一帧都是心动",
    image: "https://readdy.ai/api/search-image?query=Romantic%20sunset%20scene%20with%20cherry%20blossom%20trees%20in%20full%20bloom%2C%20soft%20pink%20and%20golden%20light%2C%20dreamy%20atmosphere%2C%20cinematic%20composition%2C%20romance%20film%20genre%20visual%2C%20clean%20artistic%20background&width=600&height=400&seq=index-04&orientation=landscape",
  },
  {
    id: 5,
    title: "喜剧欢乐汇",
    count: "296部",
    description: "笑到停不下来，治愈不开心",
    image: "https://readdy.ai/api/search-image?query=Bright%20colorful%20comedy%20theater%20stage%20with%20warm%20spotlights%2C%20cheerful%20vibrant%20atmosphere%2C%20golden%20and%20red%20curtains%2C%20cinematic%20composition%2C%20comedy%20film%20genre%20visual%2C%20clean%20background&width=600&height=400&seq=index-05&orientation=landscape",
  },
  {
    id: 6,
    title: "动漫二次元",
    count: "1,024部",
    description: "日漫国漫一网打尽，追番必备",
    image: "https://readdy.ai/api/search-image?query=Anime%20style%20colorful%20cityscape%20with%20cherry%20blossoms%20and%20vibrant%20neon%20signs%2C%20illustration%20aesthetic%2C%20bright%20and%20cheerful%20color%20palette%2C%20cinematic%20composition%2C%20anime%20genre%20visual%2C%20clean%20background&width=600&height=400&seq=index-06&orientation=landscape",
  },
  {
    id: 7,
    title: "纪录片精选",
    count: "188部",
    description: "自然、历史、人文，看真实世界",
    image: "https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20African%20savanna%20with%20wildlife%20at%20sunset%2C%20golden%20warm%20light%2C%20natural%20documentary%20style%2C%20cinematic%20wide%20angle%2C%20nature%20film%20genre%20visual%2C%20clean%20background&width=600&height=400&seq=index-07&orientation=landscape",
  },
  {
    id: 8,
    title: "恐怖惊悚馆",
    count: "165部",
    description: "深夜慎入，挑战你的胆量极限",
    image: "https://readdy.ai/api/search-image?query=Dark%20abandoned%20Victorian%20mansion%20in%20foggy%20forest%2C%20moonlight%20through%20bare%20trees%2C%20eerie%20atmosphere%2C%20cinematic%20horror%20composition%2C%20film%20genre%20visual%2C%20clean%20mysterious%20background&width=600&height=400&seq=index-08&orientation=landscape",
  },
];

export const featuresData = [
  {
    id: 1,
    icon: "ri-4k-line",
    title: "真4K超清画质",
    description: "全站80%以上资源支持4K分辨率，HDR与杜比视界加持，每一帧细节都纤毫毕现，在大屏幕上也能获得影院级观影体验。",
  },
  {
    id: 2,
    icon: "ri-speed-up-line",
    title: "极速加载不缓冲",
    description: "全球CDN加速节点覆盖，智能码率自适应技术，无论宽带还是移动网络，都能实现秒开即播，告别加载等待。",
  },
  {
    id: 3,
    icon: "ri-download-cloud-2-line",
    title: "高速离线下载",
    description: "支持多线程高速下载，4K片源也能快速保存到本地。通勤、旅行无网络也能畅享高清影视，自由观影不受限。",
  },
  {
    id: 4,
    icon: "ri-shield-check-line",
    title: "纯净无广告体验",
    description: "全程无弹窗、无插播广告、无捆绑软件，专注观影体验本身。安全绿色，不收集隐私信息，让你看得安心。",
  },
];

export const commentsData = [
  {
    id: 1,
    name: "影迷小陈",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Chinese%20man%2C%20friendly%20smile%2C%20clean%20white%20background%2C%20natural%20lighting%2C%20professional%20photography&width=80&height=80&seq=avatar-01&orientation=squarish",
    date: "2026-07-28",
    content: "用了这么多影视站，91电影视频的4K画质是真的顶！星际迷航新纪元那个IMAX画质简直绝了，关键还一点都不卡，推荐给所有追求画质的朋友。",
    rating: 5,
  },
  {
    id: 2,
    name: "追剧少女喵",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Chinese%20woman%2C%20warm%20smile%2C%20clean%20white%20background%2C%20natural%20lighting%2C%20professional%20photography&width=80&height=80&seq=avatar-02&orientation=squarish",
    date: "2026-07-26",
    content: "山河令续集全网首发的速度太快了！每天下班第一件事就是打开91刷更新，画质清晰、更新准时，追剧党狂喜！离线下载功能通勤路上太实用了。",
    rating: 5,
  },
  {
    id: 3,
    name: "老张说电影",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20middle-aged%20Chinese%20man%20with%20glasses%2C%20warm%20expression%2C%20clean%20white%20background%2C%20natural%20lighting%2C%20professional%20photography&width=80&height=80&seq=avatar-03&orientation=squarish",
    date: "2026-07-25",
    content: "片库确实全，很多冷门老片都能找到高清版本。纪录片专区的BBC系列画质修复得相当不错，收藏夹都快装不下了。希望继续保持更新速度！",
    rating: 4,
  },
  {
    id: 4,
    name: "阿杰的周末影单",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Chinese%20man%20in%20casual%20style%2C%20confident%20smile%2C%20clean%20white%20background%2C%20natural%20lighting%2C%20professional%20photography&width=80&height=80&seq=avatar-04&orientation=squarish",
    date: "2026-07-24",
    content: "无广告这点真的良心！现在找个没广告的网站太难了。画质好、更新快、还免费，已经安利给身边所有朋友了，周末电影之夜就靠它了。",
    rating: 5,
  },
];

export const updatesData = [
  {
    id: 1,
    date: "2026-08-01",
    tag: "新片上线",
    title: "《星际迷航：新纪元》4K HDR版本全网首发",
    description: "年度科幻巨制正式登陆平台，支持4K HDR与杜比全景声，带来沉浸式星际冒险体验。",
  },
  {
    id: 2,
    date: "2026-07-31",
    tag: "剧集更新",
    title: "《山河令：续》大结局已上线，全集52集4K完整收录",
    description: "口碑爆款古装剧迎来大结局，全系列4K杜比版本同步更新，一次看个够。",
  },
  {
    id: 3,
    date: "2026-07-30",
    tag: "片库扩容",
    title: "纪录片专区新增BBC《蓝色星球》全系列4K修复版",
    description: "经典自然纪录片高清修复，每一帧都可做壁纸，自然爱好者不可错过。",
  },
  {
    id: 4,
    date: "2026-07-29",
    tag: "功能升级",
    title: "播放器全面升级：新增AI画质增强与智能字幕匹配",
    description: "自研AI引擎实时优化低画质片源，智能匹配多语言字幕，观影体验再上新台阶。",
  },
  {
    id: 5,
    date: "2026-07-28",
    tag: "热播推荐",
    title: "《花月往事》播放量突破400万，年代剧新标杆",
    description: "精良制作与感人剧情引发全网讨论，4K臻彩画质还原民国风华。",
  },
  {
    id: 6,
    date: "2026-07-27",
    tag: "新片上线",
    title: "《暗夜追踪》悬疑大片上线，烧脑反转好评如潮",
    description: "韩国导演倾力打造犯罪悬疑力作，剧情层层递进，考验你的推理能力。",
  },
  {
    id: 7,
    date: "2026-07-26",
    tag: "专题策划",
    title: "「暑期档必看」专题上线，精选50部高分影片陪你过夏天",
    description: "从动作大片到温馨动画，编辑部精选暑期片单，全家老少都有得看。",
  },
];

export const carouselData = [
  {
    id: 1,
    title: "科幻纪元：从《银翼杀手》到《星际迷航》",
    description: "跨越四十年的科幻电影进化史，从赛博朋克的阴暗街巷到浩瀚星海的壮丽征程，精选50部里程碑式科幻作品，带你领略人类想象力的极限。",
    tag: "专题策划",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20collage%2C%20futuristic%20city%20blending%20with%20deep%20space%20nebula%2C%20warm%20golden%20and%20deep%20blue%20color%20palette%2C%20epic%20cinematic%20atmosphere%2C%20professional%20film%20feature%20visual%2C%20clean%20gradient%20background&width=1200&height=600&seq=carousel-01&orientation=landscape",
  },
  {
    id: 2,
    title: "国剧之光：近五年高分华语剧集盘点",
    description: "从古装权谋到都市情感，华语剧集正迎来黄金时代。我们为你整理了近五年豆瓣8.5分以上的口碑好剧，每一部都值得细细品味。",
    tag: "编辑精选",
    image: "https://readdy.ai/api/search-image?query=Chinese%20traditional%20architecture%20blending%20with%20modern%20city%20skyline%20at%20sunset%2C%20warm%20golden%20hour%20light%2C%20cinematic%20wide%20angle%2C%20cultural%20fusion%20atmosphere%2C%20professional%20film%20feature%20visual%2C%20clean%20background&width=1200&height=600&seq=carousel-02&orientation=landscape",
  },
  {
    id: 3,
    title: "导演大师课：诺兰电影作品全解析",
    description: "时间、记忆、梦境——克里斯托弗·诺兰用镜头构建了一个又一个令人着迷的叙事迷宫。从《记忆碎片》到《奥本海默》，深度解析诺兰的视听语言与叙事哲学。",
    tag: "深度解析",
    image: "https://readdy.ai/api/search-image?query=Abstract%20cinematic%20composition%20with%20clock%20gears%20and%20film%20strips%20intertwined%2C%20dark%20and%20gold%20color%20scheme%2C%20mysterious%20atmosphere%2C%20conceptual%20film%20art%2C%20clean%20professional%20background&width=1200&height=600&seq=carousel-03&orientation=landscape",
  },
  {
    id: 4,
    title: "夏日影单：空调房里的世界旅行",
    description: "不能出远门的夏天，就让电影带你环游世界。从巴黎街头到东京小巷，从非洲草原到南极冰川，30部电影，30个目的地，开启你的银幕之旅。",
    tag: "主题合集",
    image: "https://readdy.ai/api/search-image?query=World%20map%20artistic%20illustration%20with%20film%20elements%20and%20travel%20icons%2C%20warm%20summer%20color%20palette%20with%20golden%20and%20teal%20tones%2C%20adventurous%20atmosphere%2C%20cinematic%20travel%20visual%2C%20clean%20background&width=1200&height=600&seq=carousel-04&orientation=landscape",
  },
  {
    id: 5,
    title: "动画电影：不只是给孩子看的艺术",
    description: "从吉卜力的手绘温度到皮克斯的数字魔法，动画电影用最纯粹的方式讲述最深刻的故事。精选30部跨越年龄界限的动画佳作，成年人也会热泪盈眶。",
    tag: "特别推荐",
    image: "https://readdy.ai/api/search-image?query=Magical%20animation%20style%20fantasy%20landscape%20with%20floating%20islands%20and%20colorful%20skies%2C%20soft%20dreamy%20lighting%2C%20whimsical%20atmosphere%2C%20artistic%20illustration%20visual%2C%20clean%20enchanting%20background&width=1200&height=600&seq=carousel-05&orientation=landscape",
  },
];

export const topicsData = [
  { id: 1, name: "4K超清", count: "2,386部", color: "primary" },
  { id: 2, name: "科幻大片", count: "386部", color: "accent" },
  { id: 3, name: "悬疑烧脑", count: "274部", color: "secondary" },
  { id: 4, name: "国产好剧", count: "652部", color: "primary" },
  { id: 5, name: "好莱坞精选", count: "892部", color: "accent" },
  { id: 6, name: "动漫番剧", count: "1,024部", color: "secondary" },
  { id: 7, name: "韩剧热播", count: "318部", color: "primary" },
  { id: 8, name: "纪录片", count: "188部", color: "accent" },
  { id: 9, name: "院线新片", count: "126部", color: "secondary" },
  { id: 10, name: "经典老片", count: "456部", color: "primary" },
];

export const cardsData = [
  {
    id: 1,
    title: "播放器使用指南",
    description: "详解91电影视频播放器的全部功能：画质切换、倍速播放、字幕设置、画面比例调整等实用技巧。",
    icon: "ri-play-circle-line",
    date: "2026-07-30",
    image: "https://readdy.ai/api/search-image?query=Modern%20video%20player%20interface%20design%20with%20controls%20on%20dark%20background%2C%20minimalist%20UI%2C%20clean%20tech%20aesthetic%2C%20soft%20glow%20effects%2C%20professional%20product%20visual%2C%20clean%20background&width=600&height=400&seq=cards-01&orientation=landscape",
  },
  {
    id: 2,
    title: "如何选择最佳画质",
    description: "不同网络环境下如何选择合适的清晰度？4K、1080P、720P各有什么适用场景？一文说清楚。",
    icon: "ri-4k-line",
    date: "2026-07-28",
    image: "https://readdy.ai/api/search-image?query=TV%20screen%20displaying%20high%20quality%20nature%20scene%20in%20modern%20living%20room%2C%20warm%20ambient%20lighting%2C%20cozy%20home%20theater%20setup%2C%20clean%20minimalist%20interior%2C%20professional%20photography&width=600&height=400&seq=cards-02&orientation=landscape",
  },
  {
    id: 3,
    title: "离线下载全攻略",
    description: "支持多线程高速下载，WiFi自动缓存更新剧集。一键管理本地存储空间，观影不受网络限制。",
    icon: "ri-download-2-line",
    date: "2026-07-25",
    image: "https://readdy.ai/api/search-image?query=Smartphone%20showing%20download%20progress%20screen%20with%20movie%20thumbnails%2C%20modern%20mobile%20app%20interface%2C%20clean%20tech%20aesthetic%2C%20soft%20natural%20lighting%2C%20professional%20product%20visual&width=600&height=400&seq=cards-03&orientation=landscape",
  },
  {
    id: 4,
    title: "投屏到电视：大屏观影指南",
    description: "支持DLNA、AirPlay、Miracast等多种投屏协议，一步操作将手机画面投射到电视，全家一起看大片。",
    icon: "ri-cast-line",
    date: "2026-07-22",
    image: "https://readdy.ai/api/search-image?query=Family%20watching%20movie%20on%20large%20TV%20screen%20in%20cozy%20living%20room%2C%20warm%20evening%20atmosphere%2C%20dim%20lighting%2C%20comfortable%20home%20theater%20setting%2C%20professional%20photography%2C%20clean%20composition&width=600&height=400&seq=cards-04&orientation=landscape",
  },
  {
    id: 5,
    title: "字幕与多语言支持",
    description: "智能匹配中英双语字幕，支持在线搜索、调整字体大小颜色和显示位置，外语片观影无障碍。",
    icon: "ri-subtract-line",
    date: "2026-07-20",
    image: "https://readdy.ai/api/search-image?query=Movie%20scene%20with%20subtitles%20overlay%20on%20cinematic%20frame%2C%20warm%20theater%20atmosphere%2C%20professional%20film%20aesthetic%2C%20clean%20composition%2C%20editorial%20photography%20style&width=600&height=400&seq=cards-05&orientation=landscape",
  },
];

export const contactData = {
  title: "联系我们",
  description: "如果你有片源需求、问题反馈或合作意向，欢迎通过以下方式与我们取得联系。我们重视每一位用户的建议，共同打造更好的观影平台。",
  email: "feedback@91movie.vip",
  wechat: "Movie91_Official",
  qq: "800111222",
  tips: "工作时间：每日 9:00 - 24:00，节假日不休。反馈将在24小时内处理回复。",
};

export const faqData = [
  {
    id: 1,
    question: "91电影视频需要付费吗？",
    answer: "完全免费。91电影视频始终坚持免费观影理念，所有电影、电视剧、综艺、动漫资源均无需付费即可在线观看和下载。我们通过合理的运营方式维持平台运转，不会向用户收取任何费用。",
  },
  {
    id: 2,
    question: "为什么有些视频播放会卡顿？",
    answer: "播放卡顿通常与您的网络环境有关。建议检查当前网络速度，4K画质建议至少10Mbps带宽。您也可以尝试切换至1080P或720P清晰度来获得更流畅的体验。我们的智能码率自适应技术会自动为您选择最佳画质。",
  },
  {
    id: 3,
    question: "支持哪些设备观看？",
    answer: "91电影视频支持全平台访问：电脑端通过浏览器直接访问、手机端可通过浏览器或APP观看、平板和智能电视也完美适配。支持Chrome、Safari、Edge等主流浏览器，iOS和Android系统全面兼容。",
  },
  {
    id: 4,
    question: "下载的视频可以离线观看吗？",
    answer: "当然可以。下载的视频文件为标准MP4格式，保存在您的设备本地存储中，无需网络即可随时观看。支持多线程高速下载，一部4K电影通常只需几分钟即可完成下载。",
  },
  {
    id: 5,
    question: "片库更新频率是怎样的？",
    answer: "我们保持每日更新，院线新片下映后通常在1-2周内上线高清版本，热播剧集一般在播出后24小时内更新。遇到热门大片和口碑剧集，我们会优先处理，争取以最快速度呈现给观众。",
  },
  {
    id: 6,
    question: "如何搜索我想看的影片？",
    answer: "网站首页顶部设有搜索框，输入影片名称、导演、演员或关键词即可快速检索。您也可以通过顶部分类导航按类型、年份、地区等维度浏览片库，专题合集会定期整理推荐高分好片。",
  },
];

export const aboutData = {
  title: "关于91电影视频",
  content: "91电影视频创立于2020年，致力于为广大影迷打造一个纯净、高品质的在线影视平台。我们深知影视爱好者对画质和流畅度的执着追求，因此从创立之初就将'4K超清 + 极速播放'作为核心标准。经过多年积累，平台已收录超过20,000部高清影视资源，涵盖电影、电视剧、综艺、动漫、纪录片等全品类内容。我们的技术团队持续优化播放引擎和CDN加速网络，确保无论用户身处何地，都能获得流畅的观影体验。未来，91电影视频将继续坚持免费、纯净、高质量的运营理念，不断丰富片库内容，提升技术实力，为全球华语观众提供更好的观影服务。",
  stats: [
    { value: "20,000+", label: "片库总数" },
    { value: "5,000万+", label: "累计播放" },
    { value: "2020年", label: "创立年份" },
  ],
};

export const navLinks = [
  { name: "首页", href: "#hero" },
  { name: "精选视频", href: "#media" },
  { name: "专题合集", href: "#index" },
  { name: "焦点专题", href: "#carousel" },
  { name: "更新快讯", href: "#updates" },
  { name: "热播榜单", href: "#ranking" },
  { name: "联系我们", href: "#contact" },
];